
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(Flits.Metafields.IS_SOCIAL_LOGIN_PAID && Flits.Metafields.IS_SOCIAL_LOGIN_ENABLE){
    if(window.flitsObjects.allCssJs.socialLoginJs){
      Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  }

if(Flits.Metafields.IS_STORE_CREDIT_PAID && Flits.Metafields.is_store_credit_enable && window.flitsObjects.storeData.customer_id != -1){
    Flits.LoadStyleScript('cartJs',window.flitsObjects.allCssJs.cartJs.url);
  }
  Flits(document).on('Flits:StoreCreditCart:Loaded', function(event){  
   var data = event.detail.settings;
     data.checkoutButtonSelectors = ["input[name='checkout']", "[href$='checkout']","form[action='/cart']"];
 });
  
  Flits(document).on('Flits:Navigation:Loaded',function(event){
   var navs=event.detail.settings.navs;
     //  var obj={
     //      title: Flits.t('Flits.locals.navigation.about_us', "Notre histoire"),
     //  	url:'https://nureskin.fr/pages/a-propos-de-nous',
     //  	target: 0,
     //  	menuClass: null,
     //  	badge: null,
     //  	icon: '<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>',
     //  	isShow: 1,
     //  	loader: {
     //  		loader_class: null
     //  	},
     //  	body_html: null
     //  };
     // if(navs[9].url="#a-propos-de-nous"){
     //   navs.splice(11,1,obj);
     // }
      var faqs={
        title: Flits.t('Flits.locals.navigation.about_us', "FAQs et Contact"),
    	url:'pages/faq-contact',
    	target: 0,
    	menuClass: null,
    	badge: null,
    	icon: '<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>',
    	isShow: 1,
    	loader: {
    		loader_class: null
    	},
    	body_html: null
    };
    navs.splice(12,1,faqs);

    var collections={
        title: Flits.t('Flits.locals.navigation.about_us', "Nos anciens produits"),
    	url:'https://nureskin.fr/collections/nos-anciens-produits',
    	target: 0,
    	menuClass: null,
    	badge: null,
    	icon: '<svg class="flits-nav-caret-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 284.929 284.929" style="enable-background:new 0 0 284.929 284.929;" xml:space="preserve" class=""><g><g> <path d="M282.082,76.511l-14.274-14.273c-1.902-1.906-4.093-2.856-6.57-2.856c-2.471,0-4.661,0.95-6.563,2.856L142.466,174.441   L30.262,62.241c-1.903-1.906-4.093-2.856-6.567-2.856c-2.475,0-4.665,0.95-6.567,2.856L2.856,76.515C0.95,78.417,0,80.607,0,83.082   c0,2.473,0.953,4.663,2.856,6.565l133.043,133.046c1.902,1.903,4.093,2.854,6.567,2.854s4.661-0.951,6.562-2.854L282.082,89.647   c1.902-1.903,2.847-4.093,2.847-6.565C284.929,80.607,283.984,78.417,282.082,76.511z" data-original="#000000" class="active-path" data-old_color="#000000" fill="#FFFFFF"/> </g></g> </svg>',
    	isShow: 1,
    	loader: {
    		loader_class: null
    	},
    	body_html: null
    };
    navs.splice(13,1,collections);

 }) 

  Flits(document).ready(function() {
      setTimeout(function(){
      var checkSelector = Flits('.content-box').hasClass('flits-order-status');
      if (Flits(checkSelector).length == 1) {
        if (window.flitsObjects.storeData.customer_id != -1) {
          Flits("<a href='https://nureskin.fr/pages/votre-acces-a-notre-communaute-ty-card' class='btnOrderStatus'>créer un compte</a>").appendTo('.flits-order-status');
          Flits("<a href='https://nureskin.fr/account#howToManageCredit' class='btnOrderStatus'>Gérer les crédits</a>").appendTo('.flits-order-status');
          Flits( ".btnOrderStatus" ).wrapAll( "<div class='btnOrderStatusMaindiv' />");
         }
          }
        }, 4000);
    });
  
}(Flits));
